
//import { Options, Vue} from "vue-class-component";
import { inject, defineComponent, onMounted, onUpdated, reactive, ref, toRefs} from 'vue';
import Card from "./components/Card.vue";
import Button from "./components/Button.vue";
import AppConfig from './models/appConfig.model';
import LazyLoad from 'vanilla-lazyload';
import { CustomWindow, CardList } from "./models/types"; 
 
declare let window: CustomWindow;


export default defineComponent ({
  components: { Card, Button  },
  props: {
    appconfig: {
      type: AppConfig,
      required: true
    }
  },
  setup(props) {
    const axios: any = inject('axios')  // inject axios   
    
    let cards: CardList = reactive({Cards:[]});
    let currentPage = 1;
    let pageSize = 10;
    let total = 0;
    let totalPages = 0;
    let loading = ref(true);
    let baseAddress = window.location.origin;
    let buttonDisabled = ref(true);
    let showButton = ref(false);
    let excludedCardIds : number[] = [];
    let axiosConfig = {
          method: 'HEAD',
          mode: 'no-cors',
          headers: {
            'Access-Control-Allow-Origin': '*',
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          withCredentials: true,
          credentials: 'same-origin',
          crossdomain: true
      }
      
    onUpdated(()=>{
      window.lazyLoadInstance.update();  
    });
    onMounted(() => {
        window.lazyLoadInstance = new LazyLoad({
          elements_selector: ".lazy"
      });
      //add excluded Node
      excludedCardIds.push(props.appconfig.excludeNode); 
      //get cards for initial view
      let api = baseAddress + props.appconfig.initialApi + '?topics=' + props.appconfig.topics 
      + '&nodes=' +  props.appconfig.cardNodes + '&cardCount='+ props.appconfig.cardCount + 
      '&noNews=' + props.appconfig.excludeNews + '&excludes=' + props.appconfig.excludeNode;
      axios.get(api,axiosConfig).then((response) =>{
        cards.Cards = cards.Cards && cards.Cards.length >0 ? cards.Cards.concat(response.data.Cards) : response.data.Cards;            
        //add ids to excluded list
        for (var i=0; i < response.data.Cards.length; i++){
          if(response.data.Cards[i] && response.data.Cards[i].Id ){
            excludedCardIds.push(response.data.Cards[i].Id); 
           
            loading.value = false;    
          }
           if(response.data.Cards[i] && response.data.Total && response.data.Total > props.appconfig.cardCount){           
            buttonDisabled.value = false;  
            showButton.value = true;      
          }
        }
      })
    });

    const getCards = ()=>{ 
      if(buttonDisabled.value)return;
      //dynamically add page, size, topics
        let api = baseAddress + props.appconfig.loadApi + '?topics=' + props.appconfig.topics 
        + '&excludes=' + excludedCardIds + '&noNews=' + props.appconfig.excludeNews + '&excludes=' + props.appconfig.excludeNode;
        
      axios.get(api,axiosConfig).then((response) =>{
        cards.Cards = cards.Cards && cards.Cards.length >0 ? cards.Cards.concat(response.data.Cards) : response.data.Cards;            
        total = response.data.Total;
        totalPages = Math.ceil(total / pageSize);
        if(currentPage >= totalPages){
          buttonDisabled.value = true;
        }            
          
        currentPage = currentPage + 1;
      })          
      
    }  
    return { getCards, cards, buttonDisabled, loading, showButton }  
  } 
  
})
